<div class="page-info">
  <h2 class="page-info-title">
    {{ resourceName() }}
  </h2>
  @if (loginAndRoles()) {
    <div class="page-info-user">
      <span>{{ loginAndRoles()?.displayRole }}</span>
      <span>{{ loginAndRoles()?.login }}</span>
    </div>
  }
</div>
